import type { RefObject } from 'react';

/**
 * `fallbackFocusRef` target for a modal whose opener is gone (a menu item that unmounted) or never existed (a keyboard
 * shortcut): the page's main landmark, which AppShell renders as `<main id="main-content" tabIndex={-1}>`.
 * Resolved when focus is returned, so it needs no render-time lookup.
 */
export const mainContentFocusRef: RefObject<HTMLElement | null> = {
  get current() {
    return typeof document === 'undefined' ? null : document.getElementById('main-content');
  },
} as RefObject<HTMLElement | null>;
